import get from "lodash/get";
import { array, object, string } from "prop-types";
import React from "react";
import { StoryCard } from "../../../arrow/components/Molecules/StoryCard";
import LiveButton from "../../atoms/live-button";
import { useDeviceType } from "../../customHooks/useDeviceType";
import { Newsletter } from "../../molecules/Newsletter";
import { getCategoryAndSubCategory, getTemplateName, useTrackWidgetImpression } from "../../../ga-utils";
import YouTube from "react-youtube";
import ImagewithAnchor from "../../../arrow/components/Molecules/ImagewithAnchor";

import "./four-col-ten-stories.m.css";

const YoutubeIframe = ({ collection }) => {
  const onPlayerReady = (event) => {
    event.target.playVideo();
  };

  return (
    <div styleName="yt-container">
      <YouTube
        id="videoFrame"
        videoId={collection.summary}
        className="yt-iframe"
        opts={{
          width: "100%",
          height: "100%",
          playerVars: {
            autoplay: 1,
            mute: 1,
            controls: 1,
            rel: 0,
            modestbranding: 1,
            playsinline: 1,
          },
        }}
        onReady={onPlayerReady}
      />
    </div>
  );
};

export const FourColTenStories = (props) => {
  const { collection, stories, config, data, pageType } = props;
  const { magazineWidget } = data;
  if (stories.length < 0) {
    return null;
  }
  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";
  const { enable_newsletter = false } = get(collection, ["associated-metadata"], {});
  const budgetBannerDesktopImageUrl = get(
    collection,
    ["associated-metadata", "budget_banner_desktop_image_url"],
    false
  );
  const budgetBannerDesktopImageUrlCta = get(
    collection,
    ["associated-metadata", "budget_banner_desktop_image_url_cta"],
    false
  );
  const budgetBannerMobileImageUrl = get(collection, ["associated-metadata", "budget_banner_mobile_image_url"], false);
  const budgetBannerMobileImageUrlCta = get(
    collection,
    ["associated-metadata", "budget_banner_mobile_image_url_cta"],
    false
  );
  const budgetBlackTheme = get(collection, ["associated-metadata", "budget_black_theme"], false);
  const showDesktopBudgetBanner = budgetBannerDesktopImageUrl && budgetBannerDesktopImageUrlCta;
  const showMobileBudgetBanner = budgetBannerMobileImageUrl && budgetBannerMobileImageUrlCta;

  const isAdfreePage = get(config, ["subscriber"]) === "true";
  const showNewsletter = enable_newsletter && !isAdfreePage;

  const hasSummary = !!collection?.summary?.trim();

  let secondRowStartIndex = 1;

  if (!showNewsletter && !hasSummary) {
    secondRowStartIndex = 2;
  } else if (showNewsletter && hasSummary) {
    secondRowStartIndex = 0;
  }

  const thirdRowStartIndex = showNewsletter ? 5 : 6;

  let storyIndex = 1;
  if (hasSummary) {
    storyIndex = 0;
  }

  // Set up widget impression tracking
  const isBrowser = typeof window !== "undefined";
  const componentRef = useTrackWidgetImpression(
    {
      sectionName: collection?.name || "Four Col Ten Stories",
      pageType: pageType,
      location: isBrowser ? window.location : null,
      config: config,
      threshold: 0.2,
    },
    { disabled: !isBrowser }
  );

  const noAdStoryStyle = { borderBottom: stories.length > 2 || "none", paddingBottom: stories.length > 2 || 0 };
  const handleStoryClick = (story, position) => {
    if (typeof window !== "undefined" && window.dataLayer) {
      const storyUrl = `/${story.slug}`;
      const { category, subCategory, contentId } = getCategoryAndSubCategory(window.location, pageType);
      window.dataLayer.push({
        event: "dl_story_listing_component_click",
        link_position: position,
        section_name: collection?.name?.toLowerCase(),
        category: category,
        sub_category: subCategory,
        content_id: contentId,
        template_name: getTemplateName(pageType),
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
        eventCallback: function () {
          window.location.href = storyUrl;
        },
      });
    }
  };
  return (
    <div styleName={`${budgetBlackTheme ? "black-theme" : ""} four-col-ten-stories`} ref={componentRef}>
      {isDesktop && showDesktopBudgetBanner && (
        <div styleName="budget-banner">
          <a href={budgetBannerDesktopImageUrlCta}>
            <img
              src={budgetBannerDesktopImageUrl}
              width={1140}
              height={150}
              alt="Budget Banner"
              title="Budget Banner"
              loading="lazy"
            />
          </a>
        </div>
      )}
      {!isDesktop && showMobileBudgetBanner && (
        <div styleName="budget-banner">
          <a href={budgetBannerMobileImageUrlCta}>
            <img
              src={budgetBannerMobileImageUrl}
              width={360}
              height={100}
              alt="Budget Banner"
              title="Budget Banner"
              loading="lazy"
            />
          </a>
        </div>
      )}
      <div styleName="main-story-container">
        <div styleName="main-story" onClick={() => handleStoryClick(stories[0], 1)}>
          {!collection?.summary ? (
            <>
              {/* <StoryCard
              isLightTheme={!isDesktop}
              story={stories[0]}
              config={config}
              aspectRatio={[[16, 9]]}
              useImageAsBackground={isDesktop}
              showMultipleAuthor={true}
              showAuthorContent={false}
              isFeaturedImage={true} /> */}
              <ImagewithAnchor
                DefaultMainCard
                isFeaturedImage={true}
                showAuthorContent={false}
                story={stories[0]}
                config={config}
                aspectRatio={[[16, 9]]}
                mainCardImg
              />
            </>
          ) : (
            <YoutubeIframe collection={collection}></YoutubeIframe>
          )}
        </div>
        {showNewsletter ? (
          <Newsletter collection={collection} config={config} magazineWidget={magazineWidget} />
        ) : (
          stories.length > 1 && (
            <div
              styleName="story-card right-column-story"
              style={noAdStoryStyle}
              onClick={() => handleStoryClick(stories[1], 2)}
            >
              {/* <StoryCard story={stories[1]} config={config} aspectRatio={[[16, 9]]} showMultipleAuthor={true} showAuthorContent={false} addFreeCard={true} /> */}
              <ImagewithAnchor
                story={stories[storyIndex]}
                config={config}
                aspectRatio={[[16, 9]]}
                showMultipleAuthor={true}
                showAuthorContent={false}
                addFreeCard={true}
              />
            </div>
          )
        )}
      </div>
      {stories.length > secondRowStartIndex && (
        <div styleName="story-grid-container">
          {stories.slice(secondRowStartIndex, secondRowStartIndex + 4).map((story, index) => {
            const position = secondRowStartIndex + index + 1;
            return (
              <div styleName="story-card" key={story.id} onClick={() => handleStoryClick(story, position)}>
                <ImagewithAnchor
                  story={story}
                  isHorizontalWithImageLast={!isDesktop}
                  config={config}
                  aspectRatio={[[16, 9]]}
                  showAuthorContent={false}
                  isHidesubheadline={true}
                />
                {/* <StoryCard
                  isHorizontalWithImageLast={!isDesktop}
                  story={story}
                  config={config}
                  aspectRatio={[[16, 9]]}
                  showMultipleAuthor={true}
                  showAuthorContent={false}
                /> */}
              </div>
            );
          })}
        </div>
      )}
      {stories.length > thirdRowStartIndex && (
        <div styleName="story-grid-container">
          {stories.slice(thirdRowStartIndex, thirdRowStartIndex + 4).map((story, index) => {
            const position = thirdRowStartIndex + index + 1;
            return (
              <div styleName="story-card" key={story.id} onClick={() => handleStoryClick(story, position)}>
                <ImagewithAnchor
                  story={story}
                  isHorizontalWithImageLast={!isDesktop}
                  config={config}
                  aspectRatio={[[16, 9]]}
                  showAuthorContent={false}
                />
                {/* <StoryCard
                  isHorizontalWithImageLast={!isDesktop}
                  story={story}
                  config={config}
                  aspectRatio={[[16, 9]]}
                  showMultipleAuthor={true}
                  showAuthorContent={false}
                /> */}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

FourColTenStories.propTypes = {
  collection: object,
  stories: array,
  config: object,
  data: object,
  pageType: string,
};

FourColTenStories.storyLimit = 20;
